import {
    ButtonGroup,
    Divider,
    Grid,
    IconButton,
    useMediaQuery
} from '@mui/material';
import React, { useContext, useEffect, useState } from 'react';
import { Outlet, useNavigate, useSearchParams } from 'react-router-dom';
import GlobalPageHeaderText from '../../../../utility/globalPageHeaderText';
import globalStyles from '../../../../../assets/styles/global.module.scss';
import styles from '../../../../../assets/styles/componentStyles/chatbotStyles/integrations.module.scss';
import templateStyles from '../../../../../assets/styles/componentStyles/template.module.scss';
import AddIcon from '@mui/icons-material/Add';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import IconsColor from '../../../../utility/iconsColor';
import { IntegrationContext, IntegrationContextPayload } from '../../../../../context/integrationContext';
import { getCurrentActiveMenu, hasCarouselTemplateGroupManageAccess, hasChannelsManageAccess, hasFlowManageAccess, hasTemplateManageAccess, isAdmin, isValidWabaId, isWhatsAppBusinessApp, ORGANIZATION_ROLES } from '../../../../../utils/constants';
import GlobalButton from '../../../../utility/globalButton/button';
import { UserContext, UserContextPayload } from '../../../../../context/userContext';
import agent from '../../../../../services/api';
import { WhatsappTemplateContext, WhatsappTemplateContextPayload } from '../../../../../context/whatsappTemplateContext';
import SyncIcon from '@mui/icons-material/Sync';
import GlobalPopUp from '../../../../utility/globalPopUp';
import CreateWAflowPopup from './flows/createWAflow';
import { lightGreyColor, whiteColor } from '../../../../../utils/colors';
import { useShallow } from 'zustand/react/shallow';
import { useCarouselTemplateGroupStore } from '../../../../../store/carouselTemplateGroupStore';
import { GridMoreVertIcon } from '@mui/x-data-grid';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import GlobalMenu from '../../../../globalMenu';
import { globalMenuItemData } from '../../../../../models/axiosModel';
import { usePaymentConfigurationStore } from '../../../../../store/paymentConfigurationStore';
import ImportTemplatePopup from '../../../templatelibrary/utils/importTemplatePopup';
import GlobalTooltip from '../../../../utility/tooltip/globalTooltip';
import FolderOutlinedIcon from '@mui/icons-material/FolderOutlined';
import { findWhatsAppIntegration } from '../../../../../pages/ruleBasedInbox/utils';

const WhatsappChannel = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const { integrationDetails, integrationListNewStructure } = useContext(IntegrationContext) as IntegrationContextPayload;
    const { setFlagLoading, handleError, userDetail, apiRoutesPermissionAssignment } = useContext(UserContext) as UserContextPayload;
    const { getTemplateList, flagImportTemplatePopup, setFlagImportTemplatePopup, showLegacyImportPopup, setShowLegacyImportPopup } = useContext(WhatsappTemplateContext) as WhatsappTemplateContextPayload;
    const [flagCreateWAFlow, setFlagCreateWAFlow] = useState(false)
    const [createTemplateMenuAnchorEl, setCreateTemplateMenuAnchorEl] = useState<null | HTMLElement>(null);
    const id = searchParams.get('id');
    const templateID = searchParams.get('template_id');
    const draftID = searchParams.get('draft_id');
    const copyTemplate = searchParams.get('copy_template');
    const pathname = window.location.pathname.toLowerCase();
    const isSmallScreen = useMediaQuery('(max-width:600px)');
    const isTemplateInfoPath = pathname === '/channels/viewintegration/whatsapp/legacy/templateinfo';
    const isModifyTemplatePath = pathname === '/channels/viewintegration/whatsapp/templatelibrary/modifytemplate';
    const isTemplateLibraryPath = pathname.startsWith('/channels/viewintegration/whatsapp/templatelibrary');

    const smallScreen = useMediaQuery('(max-width : 600px) and (min-width : 0px)');
    const flagTabletScreen = useMediaQuery('(max-width : 900px) and (min-width : 600px)');

    const mainHeaderText = getCurrentActiveMenu(pathname)

    const { setFlagCreateTemplateGroupPopup, setSelectedTemplateGroup } = useCarouselTemplateGroupStore(
        useShallow((state) => ({
            setFlagCreateTemplateGroupPopup: state.setFlagCreateTemplateGroupPopup,
            setSelectedTemplateGroup: state.setSelectedTemplateGroup,
        }))
    );

    const { syncMetaPaymentConfigApi, getPaymentConfigurationApi } = usePaymentConfigurationStore(
        useShallow((store) => ({
            syncMetaPaymentConfigApi: store.syncMetaPaymentConfigApi, 
            getPaymentConfigurationApi: store.getPaymentConfigurationApi
        }))
    )

    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

    const isPaymentConfigurationRoute = pathname === '/channels/viewintegration/whatsapp/paymentconfiguration';
    const isIntegrationDataLoaded = Array.isArray(integrationListNewStructure);
    const currentWhatsAppIntegration = isIntegrationDataLoaded ? findWhatsAppIntegration(integrationListNewStructure, id ?? '') : null;
    const isSmbWaba = isWhatsAppBusinessApp(currentWhatsAppIntegration);
    const canAccessPaymentConfiguration =
        isPaymentConfigurationRoute &&
        isIntegrationDataLoaded &&
        Boolean(currentWhatsAppIntegration) &&
        !isSmbWaba;

    // Close payment configuration route for SMB WABA — redirect to Account Setup
    useEffect(() => {
        if (isPaymentConfigurationRoute && isIntegrationDataLoaded && id && isSmbWaba) {
            navigate(`/channels/viewintegration/Whatsapp?id=${id}`, { replace: true });
        }
    }, [isPaymentConfigurationRoute, isIntegrationDataLoaded, id, isSmbWaba]);

    const handleMenuOpen = (event: React.MouseEvent<SVGSVGElement, MouseEvent>) => {
        event.stopPropagation();
        event.preventDefault();
        setAnchorEl(event.currentTarget as unknown as HTMLElement);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const handleSyncTemplates = async () => {
        setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: true }))
        const syncWabaID = {
            waba_id: integrationDetails?.waba_id ? integrationDetails?.waba_id : ""
        }
        const response = await agent.syncWhatsappTemplate.post(syncWabaID)
        if (response.status) {
            if (integrationDetails) {
                await getTemplateList(integrationDetails.meta_integration_whatsapp_id)
            }
        }
        else {
            handleError(response);
        }
        setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: false }))
    }

    const shouldShowSyncTemplateButton = () => {
        if((isAdmin(userDetail) || userDetail?.user_organization_data?.user_organization_role_name?.toLowerCase() === ORGANIZATION_ROLES["OWNER_ROLE"]?.toLowerCase()) && hasTemplateManageAccess(apiRoutesPermissionAssignment, userDetail)){
            return true;
        }
        return false;
    }

    const headerMenuOptions: globalMenuItemData[] = [
        ...(shouldShowSyncTemplateButton() ? [{
            type: "item" as const,
            label: "Sync Templates",
            icon: <SyncIcon sx={{ color: lightGreyColor, fontSize: "20px" }} />,
            onClick: () => {
                handleMenuClose();
                handleSyncTemplates();
            },
            isDisable: !isValidWabaId(id, integrationListNewStructure)
        }] : []),
        {
            type: "item",
            label: "Import Template",
            icon: <FileDownloadOutlinedIcon sx={{ color: lightGreyColor, fontSize: "20px" }} />,
            onClick: (e: any) => {
                handleMenuClose();
                setFlagImportTemplatePopup(true)
            },
            isDisable: !isValidWabaId(id, integrationListNewStructure)
        },
        {
            type: "item",
            label: "Template Groups",
            icon: <FolderOutlinedIcon  sx={{ color: lightGreyColor, fontSize: "20px" }} />,
            onClick: (e: any) => {
                handleMenuClose();
                navigate(`/channels/viewintegration/whatsapp/carouselTemplateGroups?id=${id}`);
            },
            isDisable: !isValidWabaId(id, integrationListNewStructure)
        }
    ]

    const handleTemplateNavigation = () => {
        navigate(`/channels/viewintegration/whatsapp/templatelibrary?id=${id}`);
    };

    const handleCreateFromScratchNavigation = () => {
        navigate(`/channels/viewintegration/whatsapp/templatelibrary/modifyTemplate?id=${id}`);
    }

    const handleCreateTemplateMenuClose = () => {
        setCreateTemplateMenuAnchorEl(null);
    };

    const createTemplateMenuOptions: globalMenuItemData[] = [
        {
            type: "item",
            label: "Start from scratch",
            onClick: () => { handleCreateFromScratchNavigation(); },
        },
        {
            type: "item",
            label: "Use Template Library",
            onClick: () => { handleTemplateNavigation(); },
        },
    ];

    function getRightSideGridSize(pathname: string) {
        switch (pathname) {
            case '/channels/viewintegration/whatsapp/templatemessages':
            case '/channels/viewintegration/whatsapp/flows':
            case '/channels/viewintegration/whatsapp/carouseltemplategroups':
            case '/channels/viewintegration/whatsapp/paymentconfiguration':
            case '/channels/viewintegration/whatsapp/legacy/templateinfo':
                return {
                    lg: 8,
                    xs: 9
                }
            default:
                return {
                    lg: 12,
                    xs: 12
                }
        }

    }

    const shouldShowSyncPaymentConfigBtn = () => {
        return hasChannelsManageAccess(apiRoutesPermissionAssignment, userDetail) && canAccessPaymentConfiguration;
    }

    const syncPaymentConfig = async () => {
        setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: true }))
        const res = await syncMetaPaymentConfigApi(String(integrationDetails?.meta_integration_whatsapp_id ?? ''));
        if(res?.status){
            await getPaymentConfigurationApi(integrationDetails?.waba_id ?? '');
        } else {
            handleError(res);
        }
        setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: false }))
    }

    const onClickOfCreateTemplateGroup = () => {
        setFlagCreateTemplateGroupPopup(true);
        setSelectedTemplateGroup(null);
    }

    const shouldShowImportTemplateButton = () => {
        return (!templateID);
    }

    const renderImportTemplateButton = () => {
        return (
            <Grid item>
                {
                    smallScreen 
                    ? null
                    : flagTabletScreen 
                    ? 
                        <GlobalTooltip
                            title="Import Template"
                            placement="bottom"
                        >
                            <IconButton
                                className={`${templateStyles.importTemplateIcon}`}
                                onClick={() => setShowLegacyImportPopup(true)}
                                style={{ zIndex: 1 }}
                            >
                                <FileDownloadOutlinedIcon className={templateStyles.channelAddActionIcon} />
                            </IconButton>
                        </GlobalTooltip>
                    :
                        <GlobalButton
                            buttonText="Import Template"
                            className="borderedButtonStyle"
                            sx={{ width: '180px' }}
                            startIcon={<FileDownloadOutlinedIcon />}
                            onClick={() => {setShowLegacyImportPopup(true)}}
                            disabled={!!templateID}
                        />
                }
            </Grid>
        );
    }

    const renderCreateTemplateAction = () => {
        if (!hasTemplateManageAccess(apiRoutesPermissionAssignment, userDetail)) {
            return null;
        }

        return (
            <>
                <Grid item className={templateStyles.createTemplateBtnWrap}>
                    <ButtonGroup
                        variant="contained"
                        disableElevation
                        size="small"
                        className={templateStyles.createTemplateBtnGroup}
                    >
                        <GlobalButton
                            buttonText="Create Template"
                            className={`primaryButtonStyle ${templateStyles.createTemplateBtnMain}`}
                            startIcon={<IconsColor iconName="plus" fillColor={whiteColor} width="10px" height="10px" />}
                            onClick={handleTemplateNavigation}
                        />
                        <GlobalButton
                            buttonText={<ArrowDropDownIcon />}
                            className={`primaryButtonStyle ${templateStyles.createTemplateBtnDropdown}`}
                            onClick={(e) => setCreateTemplateMenuAnchorEl(e.currentTarget)}
                        />
                    </ButtonGroup>
                </Grid>

                <GlobalMenu
                    anchorEl={createTemplateMenuAnchorEl}
                    open={Boolean(createTemplateMenuAnchorEl)}
                    handleMenuClose={handleCreateTemplateMenuClose}
                    menuItemData={createTemplateMenuOptions}
                    transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                    anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                />
            </>
        );
    };

    function renderHeaderActions(pathname: string) {
        switch (pathname) { //template list
            case '/channels/viewintegration/whatsapp/templatemessages': {
                return <Grid item xl={4} lg={4} md={2.5} sm={2.5} xs={2.5} paddingRight={{ xs: '5px', lg: '0px' }}>
                    <Grid container className={globalStyles.globalHeadMainItemRightContainer} justifyContent="flex-end">
                        <Grid item xl={4} lg={5} md={4.5} sm={2.5} xs={2.5} className={`${globalStyles.globalHeadRightSubItem} ${templateStyles.templateListHeaderActions}`}>
                            <Grid container alignItems="center" justifyContent="flex-end" gap={1} flexWrap={"nowrap"}>
                                
                                {renderCreateTemplateAction()}

                                <Grid item display="flex" alignItems="center">
                                    <GridMoreVertIcon
                                        sx={{ cursor: "pointer", width: "auto", height: "30px" }}
                                        onClick={(e: React.MouseEvent<SVGSVGElement, MouseEvent>) => handleMenuOpen(e)}
                                    />
                                    <GlobalMenu
                                        anchorEl={anchorEl}
                                        handleMenuClose={handleMenuClose}
                                        menuItemData={headerMenuOptions}
                                        open={Boolean(anchorEl)}
                                        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                                        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                                    />
                                </Grid>

                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            }
            case '/channels/viewintegration/whatsapp/legacy/templateinfo': {
                return <Grid item lg={4} xs={2.5} paddingRight={{ xs: '5px', lg: '0px' }}>
                    <Grid container className={globalStyles.globalHeadMainItemRightContainer} justifyContent="flex-end" flexWrap={"nowrap"}>
                        {shouldShowImportTemplateButton() && (
                            renderImportTemplateButton()
                        )}
                    </Grid>
                </Grid>
            }
            case '/channels/viewintegration/whatsapp/flows': {
                return <Grid item xl={4} lg={4} md={2.5} sm={2.5} xs={2.5} paddingRight={{ xs: '5px', lg: '0px' }}>
                    <Grid container className={globalStyles.globalHeadMainItemRightContainer} justifyContent="flex-end">
                        <Grid item xl={4} lg={5} md={4.5} sm={2.5} xs={2.5} className={globalStyles.globalHeadRightSubItem}>
                            <Grid container alignItems="center" justifyContent="flex-end" gap={1} flexWrap={"nowrap"}>
                                
                                {/* Desktop View - Both Text & Icon */}
                                <Grid item className={templateStyles.addChatbotBtn}>
                                    {hasFlowManageAccess(apiRoutesPermissionAssignment, userDetail) && 
                                        <GlobalButton
                                            buttonText="Flow"
                                            className="primaryButtonStyle"
                                            startIcon={<IconsColor iconName="plus" fillColor="#fff" width="15px" height="15px" />}
                                            sx={{ width: '100px', padding: "4px 8px !important" }}
                                            onClick={() => { setFlagCreateWAFlow(true) }}
                                        />
                                    }
                                </Grid>

                                {/* Mobile View - Only Icon */}
                                <Grid item>
                                    {hasFlowManageAccess(apiRoutesPermissionAssignment, userDetail) && 
                                        <IconButton
                                            className={`${globalStyles.cmpGlobalMobileAddIcon} ${templateStyles.addChatbotIcon}`}
                                            onClick={() => { setFlagCreateWAFlow(true) }}
                                            style={{ zIndex: 1 }}
                                        >
                                            <AddIcon className={templateStyles.channelAddActionIcon} />
                                        </IconButton>
                                    }
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            }
            case '/channels/viewintegration/whatsapp/carouseltemplategroups': {
                return <Grid item xl={4} lg={4} md={2.5} sm={2.5} xs={2.5} paddingRight={{ xs: '5px', lg: '0px' }}>
                    <Grid container className={globalStyles.globalHeadMainItemRightContainer} justifyContent="flex-end">
                        <Grid item xl={4} lg={5} md={4.5} sm={2.5} xs={2.5} className={globalStyles.globalHeadRightSubItem}>
                            <Grid container alignItems="center" justifyContent="flex-end" gap={1} flexWrap={"nowrap"}>
                                <Grid item className={templateStyles.addChatbotBtn}>
                                    {hasCarouselTemplateGroupManageAccess(apiRoutesPermissionAssignment, userDetail) && 
                                        <GlobalButton
                                            buttonText='Template Group'
                                            className='primaryButtonStyle'
                                            startIcon={<IconsColor iconName="plus" fillColor={whiteColor} width="15px" height="15px" />}
                                            sx={{ width: '180px'}}
                                            onClick={() => onClickOfCreateTemplateGroup()}
                                        />
                                    }
                                </Grid>
                                 <Grid item>
                                    {hasCarouselTemplateGroupManageAccess(apiRoutesPermissionAssignment, userDetail) && 
                                        <IconButton
                                            className={`${globalStyles.cmpGlobalMobileAddIcon} ${templateStyles.addChatbotIcon}`}
                                            onClick={() => onClickOfCreateTemplateGroup()}
                                            style={{ zIndex: 1 }}
                                        >
                                            <AddIcon className={templateStyles.channelAddActionIcon} />
                                        </IconButton>
                                    }
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            }
            case '/channels/viewintegration/whatsapp/paymentconfiguration': {
                if (!canAccessPaymentConfiguration) {
                    return null;
                }
                return <Grid item xl={4} lg={4} md={2.5} sm={2.5} xs={2.5} paddingRight={{ xs: '5px', lg: '0px' }}>
                    <Grid container className={globalStyles.globalHeadMainItemRightContainer} justifyContent="flex-end">
                        <Grid item xl={4} lg={5} md={4.5} sm={2.5} xs={2.5} className={globalStyles.globalHeadRightSubItem}>
                            <Grid container alignItems="center" justifyContent="flex-end" gap={1} flexWrap={"nowrap"}>
                                {shouldShowSyncPaymentConfigBtn() &&
                                    <Grid item>
                                        <GlobalButton
                                            buttonText="Sync Configurations"
                                            className='borderedButtonStyle'
                                            sx={{ width: '200px' }}
                                            onClick={() => syncPaymentConfig()}
                                            startIcon={<SyncIcon />}
                                            disabled={!isValidWabaId(id, integrationListNewStructure)}
                                        />
                                    </Grid>
                                }
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            }
        }
    };

    return (
        <>
            {
                !isTemplateLibraryPath ?
                (
                    <Grid item xs={12} className={`${globalStyles.fullwidth} ${styles.templateWrapper}`}>
                        <Grid container sx={{ padding: { xs: '15px 20px 0', lg: '25px 25px 0 27px' } }}>
                            <Grid item xs={12}>
                                {!(isPaymentConfigurationRoute && !canAccessPaymentConfiguration) && (
                                    <>
                                        <Grid container alignItems="center" justifyContent="space-between">
                                            <Grid
                                                item
                                                lg={getRightSideGridSize(pathname)['lg']}
                                                xs={getRightSideGridSize(pathname)['xs']}
                                                sx={{ marginBottom: { xs: 0, lg: '10px' } }}
                                            >
                                                <GlobalPageHeaderText
                                                    mainHeadText={(templateID || isTemplateInfoPath || isModifyTemplatePath) ? "Template Info" : mainHeaderText}
                                                    flagMainTextOnly
                                                />
                                            </Grid>
                                            {renderHeaderActions(pathname)}
                                        </Grid>
                                        {!isSmallScreen && (
                                            <Divider className={`${globalStyles.fullwidth} ${globalStyles.dividerStyles}`} />
                                        )}
                                    </>
                                )}
                                <Outlet />
                            </Grid>
                        </Grid>
                    </Grid>
                )
                : (
                    <Grid item xs={12} className={`${globalStyles.fullwidth} ${styles.templateWrapper}`}>
                        <Grid container sx={{ padding: { xs: '15px 20px 0', lg: '10px 25px 0 27px' } }}>
                            <Grid item xs={12}>
                                <Outlet />
                            </Grid>
                        </Grid>
                    </Grid>
                )
            }

            {flagCreateWAFlow &&
                <GlobalPopUp
                    open={flagCreateWAFlow}
                    onClose={() => { setFlagCreateWAFlow(false); }}
                    // title={}
                    flagBackdrop
                    paperMinWidth={smallScreen || flagTabletScreen ? "310px" : "600px"}
                    paperMaxwidth={smallScreen || flagTabletScreen ? "610px" : "650px"}
                    flagShowCloseIcon={true}
                    handleClose={() => { setFlagCreateWAFlow(false); }}
                >
                    <CreateWAflowPopup setFlagCreateWAFlow={setFlagCreateWAFlow} />
                </GlobalPopUp>
            }

            {/* Import & Create Template Popup on Template List Page */}
            {flagImportTemplatePopup &&
                <GlobalPopUp
                    open={flagImportTemplatePopup}
                    onClose={() => { setFlagImportTemplatePopup(false); }}
                    handleClose={() => { setFlagImportTemplatePopup(false); }}
                    flagBackdrop
                    flagShowCloseIcon={true}
                    paperMinWidth={smallScreen || flagTabletScreen ? "310px" : "650px"}
                    paperMaxwidth={smallScreen || flagTabletScreen ? "610px" : "700px"}
                    titlePadding='0px'
                >
                    <ImportTemplatePopup
                        title='Import & Create Template'
                        handleClose={() => setFlagImportTemplatePopup(false)}
                        flagShowCreateTemplateButtons={true}
                        flagIsLegacyTemplate={false}
                    />
                </GlobalPopUp>
            }

            {/* Import Template Popup on Legacy Template Page */}
            {showLegacyImportPopup &&
                <GlobalPopUp
                    open={showLegacyImportPopup}
                    onClose={() => { setShowLegacyImportPopup(false); }}
                    handleClose={() => { setShowLegacyImportPopup(false); }}
                    flagBackdrop
                    flagShowCloseIcon={true}
                    paperMinWidth={smallScreen || flagTabletScreen ? "310px" : "650px"}
                    paperMaxwidth={smallScreen || flagTabletScreen ? "610px" : "700px"}
                    titlePadding='0px'
                >
                    <ImportTemplatePopup
                        title='Import Template'
                        handleClose={() => setShowLegacyImportPopup(false)}
                        flagShowCreateTemplateButtons={false}
                        flagIsLegacyTemplate={true}
                    />
                </GlobalPopUp>
            }
        </>
    );
};

export default WhatsappChannel;